import * as R from 'ramda'
import { RECEIVE_ONE_SCHOOL, RECEIVE_ERROR } from './actions'
import {
  RECEIVE_DISTRICT_FLYERS,
  RECEIVE_ONE_DISTRICT_FLYER,
  RECEIVE_ONE_SCHOOL_FLYER
} from '../flyers/actions'
import { RECEIVE_ONE_DISTRICT } from '../districts/actions'

export const reducer = (
  state = {
    isFetching: false,
    error: '',
    lastUpdated: 0,
    allIds: []
    // [id] : {
    //   ...
    // }
  },
  action
) => {
  switch (action.type) {
    case RECEIVE_ONE_SCHOOL: {
      const schoolId = action.school.school_id
      const stateSchool = state[schoolId] || {}
      const concatValues = (k, l, r) =>
        k === 'flyers' ? R.uniq(R.concat(l, r)) : r

      const school = R.mergeDeepWithKey(
        concatValues,
        stateSchool,
        action.school
      )
      return {
        ...state,
        isFetching: false,
        error: '',
        [schoolId]: school,
        allIds: R.uniq([...state.allIds, action.school.school_id])
      }
    }
    case RECEIVE_ONE_DISTRICT: {
      const concatValues = (k, l, r) =>
        k === 'flyers' ? R.uniq(R.concat(l, r)) : r

      const schools = R.mergeDeepWithKey(concatValues, state, action.schools)

      return {
        ...state,
        ...schools,
        isFetching: false,
        error: '',
        lastUpdated: action.receivedAt
      }
    }
    case RECEIVE_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error.message
      }
    }
    case RECEIVE_ONE_DISTRICT_FLYER:
    case RECEIVE_ONE_SCHOOL_FLYER:
    case RECEIVE_DISTRICT_FLYERS: {
      const schools = R.mergeDeepRight(state, action.schools)
      return {
        ...state,
        ...schools
      }
    }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/shared/redux/schools/reducer.js